import * as actionTypes from "./SalesQuoteType";

const INITIAL_STATE = {
  salesQuoteList: [],
  quoteNoList: [],
  filterCustomerList: [],
  items: [],
  itemList: [],
  customersList: [],
  taxList: [],
  warehouseList: [],
  costcenterList: [],
  paytermsList: [],
  supplyList: [],
  priceList: [],
  salesempList: [],
  salesQuote: null,
  salesQuoteById: {},
  customerAddress: [],
  customerAddressList: [],
  prjList: [],
  seriesList: [],
  hsnList: [],
  attachmentList: [],
  advanceFilterList: [],
  itemInfo: null,
  customerInfo: [],
  duplicateDoc: null,
  defaultCurrency: null,
  kitItem: null,
  udfList: [],
  emailContent: null,
  flexiQuote: null,
  basicFilterData: [],
  quoteCategoryList: [],
  bpMasterAddress: [],
  taxCodes: [],
  statusList: [],
  statusCount: [],
  costcenterList: [],
  salesQuoteItemListing: [],
  termsandCondition: [],
  quoteAttachmentData: [],
};
const SalesQuoteReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SETQUOTECATEGORY:
      return {
        ...state,
        quoteCategoryList: action.payload,
      };
    case actionTypes.SETFILTERCUSTOMERLIST:
      return {
        ...state,
        filterCustomerList: action.payload.list,
      };
    case actionTypes.SETSALESQUOTELIST:
      return {
        ...state,
        salesQuoteList: action.payload,
      };
    case actionTypes.SETBPMASTERADDRESS:
      return {
        ...state,
        bpMasterAddress: action.payload,
      };
    case actionTypes.SETTAXCODE:
      return {
        ...state,
        taxCodes: action.payload,
      };
    case actionTypes.SETITEMS:
      return {
        ...state,
        items: action.payload.list,
      };
    case actionTypes.SETCUSTOMERLIST:
      return {
        ...state,
        customersList: action.payload.list,
      };
    case actionTypes.SETPAYTERMSLIST:
      return {
        ...state,
        paytermsList: action.payload.list,
      };
    case actionTypes.SETSUPPLYLIST:
      return {
        ...state,
        supplyList: action.payload.list,
      };
    case actionTypes.SETSALESEMPLIST:
      return {
        ...state,
        salesempList: action.payload.list,
      };
    case actionTypes.SETCUSTOMERADDRESS:
      return {
        ...state,
        customerAddress: action.payload.list,
      };
    case actionTypes.SETCUSTOMERADDRESSLIST:
      return {
        ...state,
        customerAddressList: action.payload.list,
      };
    case actionTypes.SETPRICELIST:
      return {
        ...state,
        priceList: action.payload,
      };
    case actionTypes.SETPRJLIST:
      return {
        ...state,
        prjList: action.payload.list,
      };
    case actionTypes.SETTAXLIST:
      return {
        ...state,
        taxList: action.payload.list,
      };
    case actionTypes.SETCOSTCENTERLIST:
      return {
        ...state,
        costcenterList: action.payload.list,
      };
    case actionTypes.SETITEMLIST:
      return {
        ...state,
        itemList: action.payload,
      };
    case actionTypes.SETHSNLIST:
      return {
        ...state,
        hsnList: action.payload.list,
      };
    case actionTypes.SETSALESQUOTE:
      return {
        ...state,
        salesQuote: action.payload.data,
      };
    case actionTypes.SETSALESQUOTELISTBYID:
      return {
        ...state,
        salesQuoteById: action.payload,
      };
    case actionTypes.CLEARDOC:
      return {
        ...state,
        salesQuote: null,
        salesQuoteById: {},
        itemList: [],
        customerAddress: [],
        customerAddressList: [],
        itemInfo: null,
        customerInfo: [],
        duplicateDoc: null,
        flexiQuote: null,
        kitItem: null,
      };
    case actionTypes.SETATTACHMENTLIST:
      return {
        ...state,
        attachmentList: action.payload.list,
      };
    case actionTypes.SETADVANCEFILTERLIST:
      return {
        ...state,
        advanceFilterList: action.payload.list,
      };
    case actionTypes.SETITEMINFO:
      return {
        ...state,
        itemInfo: action.payload.data,
      };
    case actionTypes.SETCUSTOMERINFO:
      return {
        ...state,
        customerInfo: action.payload.data,
      };
    case actionTypes.SETDUPLICATEDOC:
      return {
        ...state,
        duplicateDoc: action.payload.data,
      };
    case actionTypes.SETDEFAULTCURRENCY:
      return {
        ...state,
        defaultCurrency: action.payload.data,
      };
    case actionTypes.SETKITITEM:
      return {
        ...state,
        kitItem: action.payload.data,
      };
    case actionTypes.SETUDFLIST:
      return {
        ...state,
        udfList: action.payload.list,
      };
    case actionTypes.SETEMAILCONTENT:
      return {
        ...state,
        emailContent: action.payload.data,
      };
    case actionTypes.SETFLEXIQUOTEDETAILS:
      return {
        ...state,
        flexiQuote: action.payload.data,
      };
    case actionTypes.SETSALESQUOTEBASICFILTERDATA:
      return {
        ...state,
        basicFilterData: { ...action.payload },
      };
    case actionTypes.SETATTACHMENTDATA:
      return {
        ...state,
        quoteAttachmentData: action.payload,
      };
    case actionTypes.SETSERIESLIST:
      return {
        ...state,
        seriesList: action.payload,
      };
    case actionTypes.SETWHSELIST:
      return {
        ...state,
        warehouseList: action.payload,
      };
    case actionTypes.SETSTATUSLIST:
      return {
        ...state,
        statusList: action.payload,
      };
    case actionTypes.SETSALESQUOTESTATUSCOUNT:
      return {
        ...state,
        statusCount: action.payload,
      };
    case actionTypes.SETCOSTCENTER:
      return {
        ...state,
        costcenterList: action.payload,
      };
    case actionTypes.SETSALESQUOTEITEMLISTING:
      return {
        ...state,
        salesQuoteItemListing: action.payload,
      };
    case actionTypes.SETTERMSANDCONDITION:
      return {
        ...state,
        termsandCondition: action.payload,
      };
    default:
      return state;
  }
};

export default SalesQuoteReducer;
